import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import BusinessWorkOrderSystemBlockData from '../../../Models/Content/BusinessWorkOrderSystemData';
 import BusinessWorkOrderSystemMain from './BusinessWorkOrderSystemMain';

export default class BusinessWorkOrderSystemBlock extends EpiComponent<BusinessWorkOrderSystemBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <BusinessWorkOrderSystemMain context={this.getContext()} contentData={this.props.data} />;
  }
}
